import { format } from 'date-fns';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { ReactElement } from 'react';

import { useGetWorkingDay } from '@/modules/workingDay/apiHooks';
import { IWorkingDay } from '@/modules/workingDay/types';
import { Pagination, Typography } from '@/shared/components/atoms';
import Tabs from '@/shared/components/atoms/Tabs';
import { JobInstanceCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Calender from '~/images/shared/calender.svg';

interface IJobInstances {
  filter: {
    search: string;
    date: string;
  };
}
const PER_PAGE = 5;
const TAB_QUERY_INDICATORE = 'crops';

export default function JobInstances({ filter }: IJobInstances): ReactElement {
  const [selectedAsset] = useStore((store) => store?.asset);

  const { t } = useTranslation('common');
  const { query } = useRouter();

  const [page, setPage] = React.useState(1);
  const onPageChange = (page: number) => {
    setPage(page);
  };
  const cropId = isNaN(
    Number(
      query?.[TAB_QUERY_INDICATORE] === ''
        ? undefined
        : query?.[TAB_QUERY_INDICATORE]
    )
  )
    ? undefined
    : Number(query?.[TAB_QUERY_INDICATORE]);

  const workLocationId = isNaN(
    Number(query?.workLocationId === '' ? undefined : query?.workLocationId)
  )
    ? undefined
    : Number(query?.workLocationId);

  const { data, isLoading } = useGetWorkingDay({
    entityId: selectedAsset?.id,
    date: filter.date,
    pageNumber: page,
    pageSize: PER_PAGE,
    searchQuery: filter.search === '' ? undefined : filter.search,
    cropId,
    workLocationId,
    todayDate: format(new Date(), 'yyyy-MM-dd'),
  });

  // reset page number when change crops's tab or change date
  React.useEffect(() => {
    setPage(1);
  }, [cropId, filter]);

  /* *********************************** tabsList ***********************************
   *  delete tab that jobInstancesCount ===0
   */
  const tabsList = data?.entityCrops?.filter((item) => item.jobInstancesCount);

  // if no data
  if (
    data?.jobInstances?.length === 0 &&
    data?.entityCrops.length === 0 &&
    // data?.totalCount === 0 &&
    !isLoading
  ) {
    return (
      <div className='flex flex-col items-center justify-center bg-white py-36'>
        <span className='rounded-full bg-primary-100 p-42'>
          <Calender className='text-60 text-primary-default' />
        </span>
        <Typography variant='h3' weight='semiBold' className='mt-24'>
          {t('no-job-instances')}
        </Typography>
      </div>
    );
  }
  // TODO: temp commit
  // else if there are job instance
  return (
    <div className='mt-11'>
      {/* if there are workLocationId that main it was redirect from worklocation with one crop 
      we hide tabs when : 
      1- redirect from home page (worklocation) and entity type farm (there are one crop)
      2- if list length after filteration === 0
      */}
      {(query?.workLocationId === '' ||
        query.workLocationId === undefined ||
        selectedAsset?.entityTypeId === 1) &&
        tabsList?.length !== 0 && (
          <Tabs<IWorkingDay.IEntityCrop>
            getLabel={(item: IWorkingDay.IEntityCrop) => item?.name}
            getValue={(item: IWorkingDay.IEntityCrop) => item?.id}
            getImage={(item: IWorkingDay.IEntityCrop) => item?.image}
            getCount={(item: IWorkingDay.IEntityCrop) =>
              item?.jobInstancesCount
            }
            tabsList={tabsList || []}
            variant='headless'
            tabClasseName='h-42 flex items-center border-xs border-neutralVariant-90 rounded-xl font-medium text-14'
            activeClassName='bg-secondary-90'
            imageWrapperClassName='rounded-full bg-outline-default'
            tabQueryIndicator={TAB_QUERY_INDICATORE}
            allInfo={{
              name: t('all'),
              count: data?.jobInstancesTotalCount,
              value: 'all',
            }}
          />
        )}
      {data?.jobInstances?.length === 0 &&
        // data?.entityCrops.length === 0 &&
        // data?.totalCount === 0 &&
        !isLoading && (
          <div className='mt-16 flex flex-col items-center justify-center bg-white py-36'>
            <span className='rounded-full bg-primary-100 p-42'>
              <Calender className='text-60' />
            </span>
            <Typography variant='h3' weight='semiBold' className='mt-24'>
              {t('no-job-instances')}
            </Typography>
          </div>
        )}
      <div className=' mt-16'>
        {data?.jobInstances?.map((jobInstance) => (
          <div key={jobInstance.id} className='mb-16'>
            <JobInstanceCard jobInstance={jobInstance} />
          </div>
        ))}

        <div className='mt-24 flex justify-center'>
          <Pagination
            onPageChange={onPageChange}
            currentPage={page}
            totalCount={data?.totalCount || 0}
            perPage={PER_PAGE}
          />
        </div>
      </div>
    </div>
  );
}
